/**
 * 司机端 — 任务列表
 * N6: 走司机身份接口 GET /transit/driver/orders（仅本人名下运输单）。
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchDriverOrders } from '@/api/transit';
import { Empty, Loading, OrderStatusTag } from '@/components/common';
import type { TransitOrder } from '@/types';

export default function DriverOrders() {
  const [orders, setOrders] = useState<TransitOrder[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDriverOrders({ page_size: 100 })
      .then((d) => {
        setOrders(d.list);
        setLoading(false);
      })
      .catch(() => {
        setOrders([]);
        setLoading(false);
      });
  }, []);

  if (loading) return <Loading />;

  return (
    <div className="driver-page">
      <div className="page-title" style={{ marginBottom: 16 }}>
        任务列表
      </div>
      {orders.length === 0 ? (
        <Empty text="暂无任务" />
      ) : (
        orders.map((o) => (
          <Link key={o.id} to={`/driver/orders/${o.id}`}>
            <div className="card" style={{ marginBottom: 12 }}>
              <div className="row-between" style={{ marginBottom: 6 }}>
                <strong>
                  {o.origin_city} → {o.destination_city}
                </strong>
                <OrderStatusTag status={o.status} />
              </div>
              <div style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--color-ink-secondary)' }}>{o.transit_no}</div>
              <div style={{ fontSize: 13, marginTop: 4 }}>
                牛只 {o.cattle_count} 头 · {o.vehicle?.plate_no ?? `车辆 #${o.vehicle_id}`}
              </div>
            </div>
          </Link>
        ))
      )}
    </div>
  );
}
